import Modal from 'react-modal';
import { mergeDeepRight } from 'ramda';
import PropTypes from 'prop-types';

import styles from './styles';

export default class EdocatModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onModalClose = ::this.onModalClose;

    const id = `${Math.random()}`.substr(2);

    window.Modals = window.Modals || [];
    window.Modals.push(id);

    this.state = {
      styles: mergeDeepRight(styles, props.styles),
      id,
    };
  }

  static propTypes = {
    className: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    onModalClose: PropTypes.func.isRequired,
    styles: PropTypes.object,
  };

  static defaultProps = {
    className: '',
    isOpen: false,
    styles: {},
  };

  componentDidMount() {
    document.documentElement.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    const index = window.Modals.findIndex(item => item === this.state.id);
    window.Modals.splice(index, 1);

    if (window.Modals.length === 0) {
      document.documentElement.style.overflow = 'initial';
      document.documentElement.style.overflowY = 'auto';
    }
  }

  onModalClose(event) {
    event && event.preventDefault();
    const { onModalClose } = this.props;
    onModalClose();
  }

  render() {
    const { className, isOpen, dontCloseOnOverlayClick } = this.props;

    return (
      <Modal
        ariaHideApp={false}
        className={className}
        contentLabel="Edocat Modal"
        isOpen={isOpen}
        onRequestClose={this.onModalClose}
        shouldCloseOnOverlayClick={!dontCloseOnOverlayClick}
        style={this.state.styles}
      >
        {this.props.children}
      </Modal>
    );
  }
}
